import type { PropsWithChildren } from "react";
import type { DefaultComponentProps } from "@/types/component.types";
import cn from "@/utils/cn";
import styles from "./GroupPanel.module.css";

interface GroupPanelProps extends DefaultComponentProps<PropsWithChildren> {
    readonly borderColor?: "subtle";
}

function GroupPanel({ borderColor, children, className }: GroupPanelProps) {
    return (
        <div
            className={cn(
                styles.container,
                borderColor && styles[borderColor],
                className
            )}
        >
            {children}
        </div>
    );
}

export default GroupPanel;
